import { DragDropContext,Draggable,Droppable,DropResult } from "@hello-pangea/dnd";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import MenuIcon from '@mui/icons-material/Menu';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import { Box,Button,Checkbox,FormControl,FormControlLabel,Grid,IconButton,InputLabel,MenuItem,Select,Stack,TextField,Tooltip } from "@mui/material";
import { SelectChangeEvent } from '@mui/material/Select';
import React,{ useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../../context/NewFormContext";
import { avaliacao,ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

const key = 'checklists.subitemModal.';

export default function Avaliacao({ subitem, itemId, indexSubitem }: props) {
  const { t } = useTranslation('translation');
  const { setModelo, modelo } = useContext(NewFormContext);
  const [pesoInput, setPesoInput] = useState(String(subitem.peso ?? 0));

  function editAvaliaton(value: number, name: string, index: number) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, avaliacao: subitem?.avaliacao?.map((av, ind) =>
                    ind === index
                      ? { ...av, valor: value, nome: name }
                      : av
                  )
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function setThreshold(value: number) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, threshold: value
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function addNewItemOnAvaliation() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                const indiceNA = subitem.avaliacao?.findIndex((ele) => ele.NA);

                if (indiceNA !== -1) {
                  const novoArray = [
                    ...(subitem.avaliacao as avaliacao[])?.slice(0, indiceNA),
                    {
                      nome: `${(subitem.avaliacao as avaliacao[])?.length + 1}`,
                      valor: modelo?.valorMaxScoring ?? 100,
                    },
                    ...(subitem.avaliacao as avaliacao[])?.slice(indiceNA),
                  ];
                  return {
                    ...subitem,
                    avaliacao: novoArray,
                  };
                } else {
                  return {
                    ...subitem,
                    avaliacao: [
                      ...(subitem?.avaliacao || []),
                      {
                        nome: `${(subitem.avaliacao as avaliacao[])?.length + 1}`,
                        valor: modelo?.valorMaxScoring ?? 100,
                      },
                    ],
                  };
                }
              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function removeItemOnAvaliation() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                const indice = subitem.avaliacao?.findIndex((ele) => ele.NA);
                if (indice !== -1) {
                  const novoArray = subitem.avaliacao?.slice(0, -2);
                  return {
                    ...subitem,
                    avaliacao: [
                      ...novoArray as avaliacao[],
                      {
                        NA: true,
                        nome: "Não se Aplica",
                        valor: -1,
                      },
                    ],
                  };
                }
                return {
                  ...subitem,
                  avaliacao: subitem.avaliacao?.slice(0, -1),
                };
              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function handleNaoSeAplica(event: React.ChangeEvent<HTMLInputElement>) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  avaliacao: event.target.checked ? [
                    ...(subitem?.avaliacao as { nome: string, valor: number }[]),
                    {
                      NA: true,
                      nome: "Não se Aplica",
                      valor: -1
                    }
                  ] : subitem.avaliacao?.slice(0, -1)
                }
                : subitem
            )
          }
          : item
      )
    }));
  };

  function handlePeso(value: number) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, peso: value
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function handlePadrao(event: SelectChangeEvent) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, padrao: parseInt(event.target.value) === -2 ? null : parseInt(event.target.value)
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function ajustaLinearidade() {
    const valorMax = modelo?.valorMaxScoring || 100;
    const novoAvalia = structuredClone(subitem.avaliacao);
    if (novoAvalia) {
      const indiceNA = novoAvalia?.findIndex((ele) => ele.NA);
      novoAvalia?.forEach((ele, i) => {
        if (indiceNA !== -1) {
          novoAvalia.splice(indiceNA, 1);
          ele.valor = Math.floor((valorMax / ((subitem.avaliacao as avaliacao[])?.length - 2)) * i);
          novoAvalia.push({ NA: true, valor: -1, nome: 'Não se aplica' });
          return novoAvalia;
        } else {
          ele.valor = Math.floor((valorMax / (novoAvalia.length - 1)) * i);
          return novoAvalia;
        }
      });
    }
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, avaliacao: novoAvalia
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function reorder(list: avaliacao[], startIndex: number, endIndex: number) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function handleDragEnd(result: DropResult) {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      subitem.avaliacao as avaliacao[],
      result.source.index,
      result.destination.index
    );

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  avaliacao: items
                }
                : subitem
            )
          }
          : item
      )
    }));
  };

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={2} width='100%'>
        <Grid size={6}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Box sx={{ width: 60 }} />
            <Box sx={{ width: 160, textAlign: 'center' }}>
              <Tooltip title={`${t(key + 'setCustomValue')}`}>
                <InfoRoundedIcon color="info" />
              </Tooltip>
            </Box>
            <Stack direction='row' spacing={2} width='100%' alignItems='center' justifyContent='center' marginTop={2}>
              <IconButton onClick={() => addNewItemOnAvaliation()}>
                <AddCircleOutlineRoundedIcon />
              </IconButton>
              <IconButton disabled={((subitem?.avaliacao as avaliacao[])?.length <= 2)
                || (((subitem?.avaliacao as avaliacao[])?.length <= 3)
                  && subitem.avaliacao?.some((ele) => ele.valor === -1))} onClick={() => removeItemOnAvaliation()}>
                <RemoveCircleOutlineRoundedIcon />
              </IconButton>
            </Stack>
            <Box sx={{ flex: 1 }} />
            <Box sx={{ width: 60, textAlign: 'center' }}>
              <Tooltip title={`${t(key + 'setLevel')}`}>
                <ReportProblemRoundedIcon color="warning" />
              </Tooltip>
            </Box>
          </Stack>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="avaliacao">
              {(provided) => (
                <Stack direction='column' spacing={.5} {...provided.droppableProps} ref={provided.innerRef}>
                  {subitem.avaliacao?.map((value, index) => (
                    <Draggable key={index} draggableId={`${subitem.id}|${index}`} index={index}>
                      {(provided) => (
                        <Stack
                          width='100%'
                          direction='row'
                          spacing={.5}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <IconButton disabled={value.valor === -1}>
                            <MenuIcon />
                          </IconButton>
                          <TextField
                            disabled={value.valor === -1}
                            type="text"
                            value={value.valor === -1 ? '' : value.valor}
                            onChange={(eve) => {
                              const newValue = eve.target.value;
                              if (/^\d*$/.test(newValue)) {
                                const parsedValue = newValue === "" ? 0 : parseInt(newValue, 10);
                                if (parsedValue >= 0 && parsedValue <= 100) {
                                  editAvaliaton(parsedValue, value.nome, index);
                                }
                              }
                            }}
                            slotProps={{ htmlInput: { style: { textAlign: 'center' } } }}
                            sx={{ width: '150px' }}
                            inputProps={{ min: 0, max: 100 }}
                          />
                          <TextField
                            disabled={value.valor === -1}
                            fullWidth
                            value={value.nome}
                            onChange={(eve) => editAvaliaton(value.valor, eve.target.value, index)} />
                          <Checkbox
                            checkedIcon={ subitem.threshold as number >= index ? <DisabledByDefaultIcon/> : <CheckBoxIcon/>}
                            color={subitem.threshold as number >= index ? 'error' : 'success'}
                            disabled={value.valor === -1}
                            checked
                            onChange={(eve) => {
                              if (index === subitem.threshold) { setThreshold(index - 1); }
                              else { setThreshold(index); }
                            }} />
                        </Stack>)}
                    </Draggable>
                  ))}
                </Stack>)}
            </Droppable>
          </DragDropContext>
        </Grid>
        <Grid size={4} paddingLeft={2.5}>
          <Stack direction='column' justifyContent='flex-start' alignItems='center' spacing={1.5}>
            <FormControlLabel labelPlacement="start"
              sx={{ alignSelf: 'flex-start' }}
              label="Habilitar campo não se aplica"
              control={<Checkbox
                checked={(subitem.avaliacao?.some((ele) => ele.NA))}
                onChange={handleNaoSeAplica} />}
            />
            <TextField
              sx={{ alignSelf: 'flex-start' }}
              label='Peso do subitem'
              type="text"
              value={pesoInput}
              onChange={(eve) => {
                const newValue = eve.target.value;
                if (/^\d*(\.\d*)?$/.test(newValue)) {
                  const parsedValue = newValue === "" || newValue === "." ? 0 : parseFloat(newValue);
                  if (parsedValue >= 0 && parsedValue <= 100) {
                    setPesoInput(newValue);
                    handlePeso(parsedValue);
                  }
                }
              }}
              slotProps={{ htmlInput: { style: { textAlign: 'center' }, min: 0, max: 100, step: 0.01 } }}
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Valor padrão</InputLabel>
              <Select
                value={subitem.padrao ?? -2}
                label="Valor padrão"
                onChange={(eve) => handlePadrao(eve as unknown as SelectChangeEvent)}
              >
                <MenuItem value={-2}>{t('checklists.subitemModal.noDefault')}</MenuItem>
                {subitem.avaliacao?.map((ele: avaliacao, index: number) => (
                  <MenuItem key={index} value={index}>{ele.nome}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button endIcon={<FormatListNumberedIcon />} onClick={ajustaLinearidade} variant="outlined">Ajustar linearidade</Button>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};
